import * as Yup from 'yup';

export const myProfileSchema = Yup.object().shape({
  name: Yup.string().required('Nome é obrigatório.')
});
